import { render, staticRenderFns } from "./ScrollToBottom.vue?vue&type=template&id=cc371684&scoped=true&"
import script from "./ScrollToBottom.vue?vue&type=script&lang=js&"
export * from "./ScrollToBottom.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToBottom.vue?vue&type=style&index=0&id=cc371684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc371684",
  null
  
)

export default component.exports